export default "<div>\n<div>\n    <h6>BI REPORT</h6>\n</div>\n<div class=\"bi_report\" [innerHTML]=\"url | safe: 'html'\"></div>\n</div>"